// SPDX-License-Identifier: AGPL-3.0-only
// Copyright (C) 2026 realvirtual GmbH <https://realvirtual.io>

/**
 * Ed25519 trust root for rv_sig model provenance.
 *
 * This is a PUBLIC key. The matching private key is held only in the
 * RV_SIGN_PRIVATE_KEY environment secret used by the publish pipeline.
 */
export const RV_SIG_ROOT_PUBLIC_KEY_BASE64 = '99rD6Wl3Jsk7w9D+WIN9/jfEXNXns0jDRV5yf4LX48U=';

